import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    Icon,
    isWeb,
    LockIcon,
    XStack,
    YStack,
} from 'smoothie';

interface KycButtonProps {
    onPress: () => void;
    disabled?: boolean;
    text?: string;
    hideSecureText?: boolean;
}

const KycButton = ({
    onPress,
    disabled,
    text = 'Continue',
    hideSecureText = false,
}: KycButtonProps) => {
    return (
        <YStack gap={12} marginTop={isWeb ? 56 : 0}>
            {!hideSecureText && (
                <XStack
                    alignItems="center"
                    justifyContent="center"
                    gap={8}
                    marginBottom={12}
                >
                    <Icon icon={LockIcon} size={14} color="$gray900" />
                    <BodyMediumRegular color="$gray900">
                        Your information is secure
                    </BodyMediumRegular>
                </XStack>
            )}
            <Button
                variant={ButtonVariant.PRIMARY}
                tone="positive"
                size={ButtonSize.LARGE}
                text={text}
                onPress={onPress}
                disabled={disabled}
            />
        </YStack>
    );
};

export default KycButton;
